import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';
import { useQuery } from '@tanstack/react-query';
import { apiGetRequest } from '@/hook/R_query/useFetch';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import { usePathname, useRouter } from 'next/navigation';
import { LoaderMain } from '@/components';
import { ReactNode, useState } from 'react';
import useInputOnchnage from '@/hook/useInputOnchnage';
import {
    setFormModal,
    setUpdateClinicId,
} from '@/lib/RTK/features/AdmissionSlice';
import FormLoginModal from '../admission/FormLoginModal';
import FormTurnModal from '../admission/FormTurnModal';
import TurnFirstSteps from './turn-first-steps';

const TurnModals = ({
    docid,
    clinic,
    // docName,
    disabled,
    trigger,
}: {
    docid: string;
    clinic: string;
    docName: string;
    disabled: boolean;
    trigger?: ReactNode;
}) => {
    const { data, isPending, isError } = useQuery({
        queryKey: ['doctor', docid, 'clinic', clinic, 'turns'],
        queryFn: () => {
            return plus_service_turn
                ? apiGetRequest(`get_plus_turns/${clinic}`)
                : clinic === 'matab'
                ? apiGetRequest(`doctor_turns/${docid}`)
                : clinic === 'online'
                ? apiGetRequest(`clinic_turns/${docid}/${clinic}`)
                : apiGetRequest(`clinic_turns/${docid}/${clinic}`);
        },
        staleTime: 1000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
    const pathName = usePathname();
    const router = useRouter();
    const [step, setStep] = useState(1);
    const [enableSubmit, setSubmitEnable] = useState(false);
    const [showTurnModal, setShowTurnModal] = useState(false);
    const [selectedValue, handleChange] = useInputOnchnage('second');

    const plus_service_turn = useAppSelector(
        (s) => s.DocTurnStatus.plus_service_turn,
    );

    const psistionModal = useAppSelector((state) => state.admission.position);
    const dispatch = useAppDispatch();

    if ((data && data?.status === 0) || isError) {
        const newPath =
            pathName[pathName.length - 1] === '/'
                ? pathName
                      .substring(0, pathName.length - 1)
                      .substring(0, pathName.lastIndexOf('/'))
                : pathName.substring(0, pathName.lastIndexOf('/'));

        router.push(newPath);
        return <LoaderMain />;
    }

    function handleResetPosition() {
        dispatch(setFormModal(''));
    }

    return (
        <>
            <Dialog
                open={showTurnModal}
                onOpenChange={(isOpen) => {
                    setShowTurnModal(isOpen);

                    if (!isOpen) {
                        setStep(1);
                        dispatch(setFormModal(''));
                    }
                }}
            >
                <DialogTrigger
                    disabled={disabled}
                    className={`${
                        trigger
                            ? 'text-black'
                            : 'bg-blue !rounded-full hover:bg-blue-400 text-white py-2.5 px-4 disabled:opacity-30 disabled:hover:bg-blue-500'
                    } !w-full h-full text-base`}
                >
                    {trigger ? (
                        trigger
                    ) : (
                        <div
                            onClick={() => {
                                dispatch(
                                    setUpdateClinicId(
                                        String(
                                            clinic === 'matab'
                                                ? 'matab'
                                                : clinic,
                                        ),
                                    ),
                                );
                            }}
                        >
                            دریافت نوبت
                        </div>
                    )}
                </DialogTrigger>
                <DialogContent className="xl:!max-w-[45%] max-w-full md:!max-w-[80%] max-h-full md:!px-2 md:!h-min !px-3 overflow-y-hidden overflow-x-hidden !bg-white md:!rounded-3xl h-full md:!max-h-[95%] sm:!overflow-hidden">
                    <DialogHeader className="hidden !py-0">
                        <DialogTitle className="text-center sm:!text-base text-sm">
                            {/* دریافت نوبت برای {docName}   */}
                        </DialogTitle>
                        <DialogDescription> </DialogDescription>
                    </DialogHeader>
                    <TurnFirstSteps
                        step={step}
                        plus_service_turn={plus_service_turn}
                        data={data}
                        setStep={setStep}
                        isPending={isPending}
                        docname={data?.result?.doctor?.name}
                        per_visit={data?.result?.doctor.per_visit}
                        selectedValue={selectedValue}
                        enableSubmit={enableSubmit}
                        setSubmitEnable={setSubmitEnable}
                        handleChange={handleChange}
                        setShowTurnModal={setShowTurnModal}
                        clinic={clinic}
                        docid={docid}
                        timeTurnfirst={{
                            first_date:
                                clinic === 'matab'
                                    ? data?.result?.doctor?.first_date
                                    : data?.result?.clinic?.first_date,
                            first_time:
                                clinic === 'matab'
                                    ? data?.result?.doctor?.first_time
                                    : data?.result?.clinic?.first_time,
                        }}
                    />
                </DialogContent>
            </Dialog>
            {psistionModal === 'formlogin' && (
                <FormLoginModal
                    docname={data?.result?.doctor?.name}
                    handleResetPosition={handleResetPosition}
                    enableSubmit={enableSubmit}
                    buttonElement={<p></p>}
                    clinic={clinic}
                    docid={docid}
                    isTurn
                />
            )}

            {psistionModal === 'formturn' && (
                <FormTurnModal
                    ids={{
                        clinicid: clinic,
                        docid: docid,
                    }}
                    docname={data?.result?.doctor?.name}
                    clinic={clinic}
                    docid={docid}
                    buttonElement={<p></p>}
                    timeTurnfirst={{
                        first_date:
                            clinic === 'matab'
                                ? data?.result?.doctor?.first_date
                                : data?.result?.clinic?.first_date,
                        first_time:
                            clinic === 'matab'
                                ? data?.result?.doctor?.first_time
                                : data?.result?.clinic?.first_time,
                    }}
                    handleResetPosition={handleResetPosition}
                    enableSubmit={enableSubmit}
                />
            )}
        </>
    );
};

export default TurnModals;
